import { _ as _getPrototypeOf, a as _possibleConstructorReturn, b as _defineProperty, O, c as _inherits, d as _classCallCheck, e as _createClass, f as _objectWithoutProperties, X } from './_chunks/dep-b05afc19.js';
import classname from './util/classname.js';
import getSizeProps from './util/size-props.js';
import { getStylesheet } from './util/check-url-and-load.js';

var _excluded = ["id", "size", "innerClass", "innerStyle"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _render(node, id, rootProps) {
  return O(node.nodeName, _objectSpread(_objectSpread({
    key: id
  }, node.attributes), rootProps), (node.children || []).map(function (child, index) {
    if (typeof child === "string") return child;
    return _render(child, "".concat(id, "-").concat(node.nodeName, "-").concat(index));
  }));
}
var IconBase = /*#__PURE__*/function (_Component) {
  _inherits(IconBase, _Component);
  var _super = _createSuper(IconBase);
  function IconBase() {
    _classCallCheck(this, IconBase);
    return _super.apply(this, arguments);
  }
  _createClass(IconBase, [{
    key: "render",
    value: function render(props) {
      var id = props.id,
        size = props.size,
        innerClass = props.innerClass,
        innerStyle = props.innerStyle,
        restProps = _objectWithoutProperties(props, _excluded);
      delete restProps.cls;
      restProps === null || restProps === void 0 ? true : delete restProps.className;
      var _getSizeProps = getSizeProps(size),
        sizeClassName = _getSizeProps.className,
        sizeStyle = _getSizeProps.style;
      var combinCls = classname("t-icon", "t-icon-".concat(id), sizeClassName, innerClass);
      return _render(this.constructor.icon, "".concat(id), _objectSpread({
        className: combinCls,
        style: _objectSpread(_objectSpread({
          fill: "none"
        }, sizeStyle), innerStyle)
      }, restProps));
    }
  }]);
  return IconBase;
}(X);
_defineProperty(IconBase, "css", [getStylesheet()]);
_defineProperty(IconBase, "icon", null);
_defineProperty(IconBase, "propTypes", {
  innerClass: String,
  innerStyle: Object,
  size: String
});

export { IconBase };
//# sourceMappingURL=icon.js.map
